export default __webpack_public_path__ + "static/media/1788.61794694.png";